import { Map, List, fromJS } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import Psfs from 'lib/psfs/Psfs'
import { LOGBOOK } from 'constants/appRouting'
import {
  LOCUS_FETCH_LIST,
  LOCUS_FETCH_LIST_FAILURE,
  LOCUS_FETCH_LIST_SUCCESS,
} from 'reducers/locus/reducer'
import {
  FETCH_FAILURE_SITE_TYPES,
  FETCH_REGION_LIST,
  FETCH_REGION_LIST_FAILURE,
  FETCH_REGION_LIST_SUCCESS,
  FETCH_SITE_TYPES,
  FETCH_SUCCESS_SITE_TYPES,
  RESET_DATA,
  CLEAR_STORE as CLEAR_STORE_MNA,
} from 'reducers/monitorsAndAlerts/reducer'

// constants
export const FETCH_EVENT_DATA_LIST = 'logbook/FETCH_EVENT_DATA_LIST'
export const SUCCESS_EVENT_DATA_LIST = 'logbook/SUCCESS_EVENT_DATA_LIST'
export const FAILURE_EVENT_DATA_LIST = 'logbook/FAILURE_EVENT_DATA_LIST'
export const SET_LOADER_FROM_EVENT_DATA_LIST =
  'logbook/SET_LOADER_FROM_EVENT_DATA_LIST'

export const FETCH_LOCUS_GROUP_LIST = 'logbook/FETCH_LOCUS_GROUP_LIST'
export const SUCCESS_LOCUS_GROUP_LIST = 'logbook/SUCCESS_LOCUS_GROUP_LIST'
export const FAILURE_LOCUS_GROUP_LIST = 'logbook/FAILURE_LOCUS_GROUP_LIST'

export const FETCH_EVENT_DATA_ITEM = 'logbook/FETCH_EVENT_DATA_ITEM'
export const SUCCESS_EVENT_DATA_ITEM = 'logbook/SUCCESS_EVENT_DATA_ITEM'
export const FAILURE_EVENT_DATA_ITEM = 'logbook/FAILURE_EVENT_DATA_ITEM'
export const CLEAR_EVENT_DATA_ITEM = 'logbook/CLEAR_EVENT_DATA_ITEM'

export const FETCH_EVENT_FORM_LISTS = 'logbook/FETCH_EVENT_FORM_LISTS'
export const SUCCESS_EVENT_FORM_LISTS = 'logbook/SUCCESS_EVENT_FORM_LISTS'
export const SUCCESS_EVENT_FORM_EVENTS = 'logbook/SUCCESS_EVENT_FORM_EVENTS'
export const SUCCESS_EVENT_FORM_CATEGORIES =
  'logbook/SUCCESS_EVENT_FORM_CATEGORIES'
export const FAILURE_EVENT_FORM_LISTS = 'logbook/FAILURE_EVENT_FORM_LISTS'
export const FAILURE_EVENT_FORM_EVENTS = 'logbook/FAILURE_EVENT_FORM_EVENTS'
export const FAILURE_EVENT_FORM_CATEGORIES =
  'logbook/FAILURE_EVENT_FORM_CATEGORIES'

export const FETCH_LOGBOOK_STATUS = 'logbook/FETCH_LOGBOOK_STATUS'
export const FETCH_LOGBOOK_SITE_GROUPS = 'logbook/FETCH_LOGBOOK_SITE_GROUPS'
export const SUCCESS_LOGBOOK_STATUS = 'logbook/SUCCESS_LOGBOOK_STATUS'
export const FAILURE_LOGBOOK_STATUS = 'logbook/FAILURE_LOGBOOK_STATUS'
export const SUCCESS_LOGBOOK_SITE_GROUPS = 'logbook/SUCCESS_LOGBOOK_SITE_GROUPS'
export const LOAD_LOGBOOK_STATUS = 'logbook/LOAD_LOGBOOK_STATUS'
export const LOAD_LOGBOOK_SITE_GROUPS = 'logbook/LOAD_LOGBOOK_SITE_GROUPS'

export const FETCH_EVENT_FORM_INFO = 'logbook/FETCH_EVENT_FORM_INFO'
export const SUCCESS_EVENT_FORM_INFO = 'logbook/SUCCESS_EVENT_FORM_INFO'
export const FAILURE_EVENT_FORM_INFO = 'logbook/FAILURE_EVENT_FORM_INFO'

export const FETCH_EVENT_LIST = 'logbook/FETCH_EVENT_LIST'
export const SUCCESS_EVENT_LIST = 'logbook/SUCCESS_EVENT_LIST'
export const FAILURE_EVENT_LIST = 'logbook/FAILURE_EVENT_LIST'

export const FETCH_SINGLE_EVENT_DATA = 'logbook/FETCH_SINGLE_EVENT_DATA'
export const SUCCESS_SINGLE_EVENT_DATA = 'logbook/SUCCESS_SINGLE_EVENT_DATA'
export const FAILURE_SINGLE_EVENT_DATA = 'logbook/FAILURE_SINGLE_EVENT_DATA'
export const CLEAR_EVENT_DATA = 'logbook/CLEAR_EVENT_DATA'

export const FETCH_SINGLE_FILLED_EVENT_DATA =
  'logbook/FETCH_SINGLE_FILLED_EVENT_DATA'
export const SUCCESS_SINGLE_FILLED_EVENT_DATA =
  'logbook/SUCCESS_SINGLE_FILLED_EVENT_DATA'
export const FAILURE_SINGLE_FILLED_EVENT_DATA =
  'logbook/FAILURE_SINGLE_FILLED_EVENT_DATA'
export const CLEAR_FILLED_EVENT_DATA = 'logbook/CLEAR_FILLED_EVENT_DATA'

export const SAVE_DAILY_ENTRY = 'logbook/SAVE_DAILY_ENTRY'
export const SAVE_BATCH_INPUTS = 'logbook/SAVE_BATCH_INPUTS'

export const SAVE_EVENT_FORM = 'logbook/SAVE_EVENT_FORM'
export const DELETE_EVENT = 'logbook/DELETE_EVENT'

export const OPEN_EVENT_FORM_MODAL = 'logbook/OPEN_EVENT_FORM_MODAL'
export const OPEN_EVENT_INFO_MODAL = 'logbook/OPEN_EVENT_INFO_MODAL'

const SET_PSFS = 'logbook/SET_PSFS'
const CLEAR_STORE = 'logbook/CLEAR_STORE'
const RESET_EVENTS_DATA = 'logbook/RESET_EVENTS_DATA'
const SET_DATA_FIELDS = 'logbook/SET_DATA_FIELDS'
const RESET_TABLE_DATA = 'logbook/RESET_TABLE_DATA'
export const SET_SINGLE_EVENT_LOADER = 'logbook/SET_SINGLE_EVENT_LOADER'

// actions
export const openEventFormModal = ActionHelper.createActionObj(
  OPEN_EVENT_FORM_MODAL,
)
export const openEventInfoModal = ActionHelper.createActionObj(
  OPEN_EVENT_INFO_MODAL,
)
export const fetchEventDataList = ActionHelper.createActionObj(
  FETCH_EVENT_DATA_LIST,
)
export const fetchLocusGroupsList = ActionHelper.createActionObj(
  FETCH_LOCUS_GROUP_LIST,
)
export const fetchEventDataItem = ActionHelper.createActionObj(
  FETCH_EVENT_DATA_ITEM,
)
export const fetchLogbookStatus = ActionHelper.createActionObj(
  FETCH_LOGBOOK_STATUS,
)
export const fetchLogbookSiteGroups = ActionHelper.createActionObj(
  FETCH_LOGBOOK_SITE_GROUPS,
)
export const clearEventDataItem = ActionHelper.createActionObj(
  CLEAR_EVENT_DATA_ITEM,
)
export const fetchEventFormList = ActionHelper.createActionObj(
  FETCH_EVENT_FORM_LISTS,
)
export const fetchEventFormInfo = ActionHelper.createActionObj(
  FETCH_EVENT_FORM_INFO,
)
export const fetchEventList = ActionHelper.createActionObj(FETCH_EVENT_LIST)
export const fetchSingleEventData = ActionHelper.createActionObj(
  FETCH_SINGLE_EVENT_DATA,
)
export const fetchSingleFilledEventData = ActionHelper.createActionObj(
  FETCH_SINGLE_FILLED_EVENT_DATA,
)
export const saveEventForm = ActionHelper.createActionObj(SAVE_EVENT_FORM)
export const deleteEvent = ActionHelper.createActionObj(DELETE_EVENT)
export const saveDailyEntry = ActionHelper.createActionObj(SAVE_DAILY_ENTRY)
export const saveBatchInputs = ActionHelper.createActionObj(SAVE_BATCH_INPUTS)
export const setSingleEventLoader = ActionHelper.createActionObj(
  SET_SINGLE_EVENT_LOADER,
)
export const clearEventData = ActionHelper.createActionObj(CLEAR_EVENT_DATA)
export const clearFilledEventData = ActionHelper.createActionObj(
  CLEAR_FILLED_EVENT_DATA,
)
export const setPsfs = ActionHelper.createActionObj(SET_PSFS)
export const clearLogBookStore = ActionHelper.createActionObj(CLEAR_STORE)
export const resetEventsData = ActionHelper.createActionObj(RESET_EVENTS_DATA)
export const setDataFields = ActionHelper.createActionObj(SET_DATA_FIELDS)
export const setLoadTableData = ActionHelper.createActionObj(
  SET_LOADER_FROM_EVENT_DATA_LIST,
)
export const resetTableData = ActionHelper.createActionObj(RESET_TABLE_DATA)

// store
const initialState = () =>
  fromJS({
    isOpenEventFormModal: false,
    isOpenEventInfoModal: false,
    isLoadTable: true,
    isLoadStatusData: false,
    isLoadSiteGroupsData: false,
    formType: null,
    tableData: {
      data: [],
      count: 0,
    },
    formLists: {
      categories: [],
      events: [],
    },
    formListLoader: false,
    categories: [],
    events: [],
    eventInfo: {},
    eventForm: {},
    eventFormLoader: false,
    locusGroupList: [],
    logbookStatusData: {
      total_count: 0,
      total_completed_count: 0,
      site_data: [],
    },
    logbookSiteGroups: List([]),
    dailyEvents: {
      events: [],
      events_in_progress: 0,
      events_complete: 0,
      events_count: 0,
    },
    singleEventData: {
      id: null,
      category_id: null,
      parameters: {
        options: [],
      },
      options: {},
      constant_value: null,
    },
    singleEventLoader: false,
    singleFilledEventData: {
      category: {},
      comment: '',
      created_by: {},
      date_created: '',
      date_updated: '',
      end_time: '',
      event_date: '',
      file: null,
      id: null,
      last_updated_by: {},
      locus: null,
      locus_group: null,
      result: null,
      start_time: '',
      parent_evt_logbook: null,
    },
    storePsfs: new Psfs(LOGBOOK),
    dataFields: [],
    filterDataLoader: false,
  })

const logbook = handleActions(
  {
    [OPEN_EVENT_FORM_MODAL]: (state, action) =>
      state
        .set('isOpenEventFormModal', Boolean(action.payload.isOpen))
        .set('formType', action.payload.type),
    [OPEN_EVENT_INFO_MODAL]: (state, action) =>
      state.set('isOpenEventInfoModal', Boolean(action.payload)),

    [SUCCESS_EVENT_DATA_LIST]: (state, action) =>
      state.set('tableData', Map(action.payload)).set('formListLoader', false),
    [FETCH_EVENT_FORM_LISTS]: state => state.set('formListLoader', true),
    [FAILURE_EVENT_DATA_LIST]: state =>
      state
        .set('tableData', Map({ data: [], count: 0 }))
        .set('formListLoader', false),
    [SET_LOADER_FROM_EVENT_DATA_LIST]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),

    [FETCH_EVENT_DATA_ITEM]: state => state.set('eventFormLoader', true),
    [SUCCESS_EVENT_DATA_ITEM]: (state, action) =>
      state.set('eventForm', Map(action.payload)).set('eventFormLoader', false),
    [combineActions(FAILURE_EVENT_DATA_ITEM, CLEAR_EVENT_DATA_ITEM)]: state =>
      state.set('eventForm', Map({})).set('eventFormLoader', false),

    [SUCCESS_EVENT_FORM_LISTS]: (state, action) =>
      state
        .set('formLists', fromJS(action.payload))
        .set('formListLoader', false),

    [SUCCESS_EVENT_FORM_EVENTS]: (state, action) =>
      state.set('events', List(action.payload)),

    [SUCCESS_EVENT_FORM_CATEGORIES]: (state, action) =>
      state.set('categories', List(action.payload)),

    [FAILURE_EVENT_FORM_LISTS]: state =>
      state.set('formLists', fromJS({ categories: [], events: [] })),

    [FAILURE_EVENT_FORM_EVENTS]: state => state.set('events', List([])),

    [FAILURE_EVENT_FORM_CATEGORIES]: state => state.set('categories', List([])),

    [SUCCESS_EVENT_FORM_INFO]: (state, action) =>
      state.set('eventInfo', Map(action.payload)),
    [FAILURE_EVENT_FORM_INFO]: state => state.set('eventInfo', Map({})),

    [SUCCESS_LOCUS_GROUP_LIST]: (state, action) =>
      state.set('locusGroupList', List(action.payload)),
    [combineActions(
      FAILURE_LOCUS_GROUP_LIST,
      RESET_DATA,
      CLEAR_STORE_MNA,
    )]: state => state.set('locusGroupList', List([])),

    [SUCCESS_LOGBOOK_STATUS]: (state, action) =>
      state.set('logbookStatusData', Map(action.payload)),
    [FAILURE_LOGBOOK_STATUS]: state =>
      state.set(
        'logbookStatusData',
        Map({
          total_count: 0,
          total_completed_count: 0,
          site_data: [],
        }),
      ),
    [SUCCESS_LOGBOOK_SITE_GROUPS]: (state, action) =>
      state.set('logbookSiteGroups', List(action.payload)),
    [LOAD_LOGBOOK_STATUS]: (state, action) =>
      state.set('isLoadStatusData', Boolean(action.payload)),
    [LOAD_LOGBOOK_SITE_GROUPS]: (state, action) =>
      state.set('isLoadSiteGroupsData', Boolean(action.payload)),

    [SUCCESS_EVENT_LIST]: (state, action) =>
      state.set('dailyEvents', Map(action.payload)),
    [FAILURE_EVENT_LIST]: state =>
      state.set('dailyEvents', initialState().get('dailyEvents')),
    [combineActions(
      FETCH_SINGLE_EVENT_DATA,
      FETCH_SINGLE_FILLED_EVENT_DATA,
    )]: state => state.set('singleEventLoader', true),

    [SUCCESS_SINGLE_FILLED_EVENT_DATA]: (state, action) => {
      const { event, ...eventInfo } = action.payload

      return state
        .set('singleEventData', Map(event))
        .set('singleFilledEventData', Map(eventInfo))
        .set('singleEventLoader', false)
    },
    [combineActions(
      FAILURE_SINGLE_FILLED_EVENT_DATA,
      CLEAR_FILLED_EVENT_DATA,
    )]: state => {
      const initState = initialState()

      return state
        .set('singleEventData', initState.get('singleEventData'))
        .set('singleFilledEventData', initState.get('singleFilledEventData'))
        .set('singleEventLoader', false)
    },

    [SUCCESS_SINGLE_EVENT_DATA]: (state, action) =>
      state
        .set('singleEventData', Map(action.payload))
        .set('singleEventLoader', false),
    [SET_PSFS]: (state, action) => state.set('storePsfs', action.payload),
    [combineActions(FAILURE_SINGLE_EVENT_DATA, CLEAR_EVENT_DATA)]: state =>
      state
        .set('singleEventData', initialState().get('singleEventData'))
        .set('singleEventLoader', false),
    [CLEAR_STORE]: () => initialState(),

    [RESET_EVENTS_DATA]: state =>
      state.set('events', List([])).set('categories', List([])),

    [RESET_TABLE_DATA]: state =>
      state.set('tableData', Map({ data: [], count: 0 })),

    [SET_DATA_FIELDS]: (state, action) =>
      state.set('dataFields', List(action.payload)),

    [SET_SINGLE_EVENT_LOADER]: (state, action) =>
      state.set('singleEventLoader', Boolean(action.payload)),
    [combineActions(
      FETCH_REGION_LIST,
      FETCH_SITE_TYPES,
      LOCUS_FETCH_LIST,
      FETCH_LOCUS_GROUP_LIST,
    )]: state => state.set('filterDataLoader', true),

    [combineActions(
      FETCH_REGION_LIST_SUCCESS,
      FETCH_REGION_LIST_FAILURE,
      FETCH_SUCCESS_SITE_TYPES,
      FETCH_FAILURE_SITE_TYPES,
      SUCCESS_LOCUS_GROUP_LIST,
      FAILURE_LOCUS_GROUP_LIST,
      LOCUS_FETCH_LIST_SUCCESS,
      LOCUS_FETCH_LIST_FAILURE,
    )]: state => state.set('filterDataLoader', false),
  },
  initialState(),
)

export default logbook
